import { APIBaseService } from './base.api';

export class ApiImagesService extends APIBaseService {
  static createImageUrl(id: number): string {
    return new URL(`${this.apiUrl}/api/images/download?imageId=${id}`).href;
  }
}
